<template>
  <div>
      <span class="font-normal cursor-pointer" @click="openModal">
          <i class="fas fa-plus text-gray-500 cursor-pointer" />
      </span>
      <ModalHeadlessUI ref="modal">
          <template #default>
              <h1 class="font-bold mb-4 text-3xl text-center">
                  Save Smart List
              </h1>
              <div>
                  <div class="bg-white overflow-hidden w-full mb-6">
                      <div class="text-gray-600 w-full flex items-center justify-between align-middle">
                          <div class="w-full">
                              <div>
                                  <div class="flex items-center justify-between align-middle p-4 w-full lg:px-24">
                                      <div class="w-full pr-4">
                                          <text-input v-model="form.name" :error="form.errors.name" class="w-full" label="Name" />
                                      </div>
                                  </div>
                              </div>
                              <div class="flex justify-center items-center mt-4 min-w-full w-full">
                                  <div>
                                      <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit" @click="saveList">Save List</loading-button>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </template>
      </ModalHeadlessUI>
  </div>
</template>

<script>
import ModalHeadlessUI from '@/Shared/ModalHeadlessUI'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import { router } from '@inertiajs/vue3'

export default {
  components: {
      ModalHeadlessUI,
      TextInput,
      LoadingButton
  },
  data() {
      return {
          form: router.form({
              name: '',
              pageUrl: '',
              order: '',
          }),
      }
  },
  methods: {
      openModal() {
          // Update pageUrl and order whenever the modal is opened
          this.form.pageUrl = window.location.pathname + window.location.search
          this.form.order = window.location.pathname + window.location.search // or customize order if needed
          this.$refs.modal.openModal()
      },
      closeModal() {
          this.$refs.modal.closeModal()
      },
      saveList() {
          const postTo = '/smartLists'
          this.form.post(postTo, {
              onSuccess: () => {
                  this.form.reset('name')
                  this.form.reset('pageUrl')
                  this.form.reset('order')
                  this.closeModal()
              },
          })
      },
  },
}
</script>
